module.exports = __webpack_public_path__ + "static/media/gallery25.889b6ea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/gallery25.jpg
// module id = 520
// module chunks = 0